// extracted by mini-css-extract-plugin
module.exports = {"DateRangePicker__CalendarSelection--is-pending":"custom_DateRangePicker__CalendarSelection--is-pending__2MYVT"};